import React, { ChangeEvent, FC, useRef, useState } from 'react';
import { ReactComponent as HeadphonesIcon } from 'bootstrap-icons/icons/headphones.svg';
import { AnswerType3, QuizQuestion } from '../../shared/types';
import quizPageStyles from '../../pages/quizPage/quizPage.module.scss';

type Props = {
  data: QuizQuestion;
  isSubmitted: boolean;
  answersState: AnswerType3[];
  setAnswersState: (state: AnswerType3[]) => void;
};

const AudioQuestion: FC<{ answer: AnswerType3; isSubmitted: boolean }> = ({ answer, isSubmitted }) => {
  const audio = useRef<HTMLAudioElement>(null);
  const [isAudioPlaying, setIsAudioPlaying] = useState<boolean>(false);

  const pronounceAudio = () => {
    const resp = audio.current?.play();
    if (resp !== undefined) {
      resp
        .then((_) => {
          // autoplay starts!
          setIsAudioPlaying(true);
        })
        .catch((error) => {
          // show error
        });
    }
  };

  const pauseAudio = () => audio.current?.pause();

  return (
    <div>
      <audio
        ref={audio}
        hidden
        src={'https://saryarqatil.kz/edit/lib/audio/' + answer.file}
        onPause={() => setIsAudioPlaying(false)}
      />
      <HeadphonesIcon
        className={`tw-text-[#0c276c] tw-w-[36px] sm:tw-w-[48px] cursor-pointer hover:opacity-80 ${!isSubmitted ? 'hover:tw-text-orange-500 tw-transition-all' : ''}`}
        width={48}
        height={48}
        onClick={pronounceAudio}
      ></HeadphonesIcon>
    </div>
  );
};

const Card: FC<Props & { answ: AnswerType3 }> = ({ data, answ, isSubmitted, answersState, setAnswersState }) => {
  const ref = useRef<HTMLInputElement>(null);
  const inputColor = isSubmitted
    ? (data.paramjs as AnswerType3[])
        .find((item) => item.id === answ.id)
        ?.answer.toLowerCase()
        .trim() === answ.answer.toLowerCase().trim()
      ? 'bg-success text-white'
      : 'bg-danger text-white'
    : 'bg-white tw-text-[#0c276c] hover:!tw-border-sky-500';

  const handleChange = (e: ChangeEvent<HTMLInputElement>, id: number) => {
    const newState = answersState.map((item) => {
      if (item.id === id) {
        return { ...item, answer: e.target.value };
      } else return item;
    });
    setAnswersState(newState);
  };

  return (
    <div key={answ.id} className="col-12 col-sm-6">
      <div
        className={`card p-2 pt-3 shadow-sm gap-3 ${!isSubmitted ? 'tw-cursor-pointer' : ''}`}
        onClick={() => ref.current?.focus()}
      >
        <AudioQuestion answer={answ} isSubmitted={isSubmitted} />
        <div className="flex-grow-1">
          <input
            ref={ref}
            disabled={isSubmitted}
            spellCheck={false}
            className={`${quizPageStyles.coloredInput} w-100 tw-h-[34px] px-3 text-center rounded-1 border border-1 border-gray focus-visible:tw-outline-[rgb(0,95,204)] tw-text-lg ${inputColor}`}
            value={answ.answer}
            onChange={(e) => handleChange(e, answ.id)}
          />
        </div>
      </div>
    </div>
  );
};

export const CardTemplate7: FC<Props> = (props) => {
  return (
    <div className="text-center px-1 px-sm-3 tw-max-w-[600px]">
      <h4 className="h3 tw-underline">{props.data.qs_main}</h4>
      <div className="py-4">
        <div className="row gx-0 gx-sm-4 gy-3 gy-sm-4 tw-items-center">
          {props.answersState.map((answ) => (
            <Card key={`temp7-${answ.id}`} answ={answ} {...props} />
          ))}
        </div>
      </div>
    </div>
  );
};
